export const dti = (...args) => {
  return args.filter(x => x !== undefined && x !== null).join('-');
};

export const buildDti = (...args) => {
  return (...subArgs) => dti(...args, ...subArgs);
};
